import React from 'react';
import { HeroSection } from './components/HeroSection';
import { HookSection } from './components/HookSection';
import { ProblemSection } from './components/ProblemSection';
import { FailedMethodsSection } from './components/FailedMethodsSection';
import { MechanismSection } from './components/MechanismSection';
import { DeliverablesSection } from './components/DeliverablesSection';
import { AudienceSection } from './components/AudienceSection';
import { HowItWorksSection } from './components/HowItWorksSection';
import { ProofSection } from './components/ProofSection';
import { FAQSection } from './components/FAQSection';
import { OfferSection } from './components/OfferSection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-cream font-sans selection:bg-gold/30 selection:text-navy" data-id="element-0">
      <HeroSection data-id="element-1" />
      <HookSection data-id="element-2" />
      <ProblemSection data-id="element-3" />
      <FailedMethodsSection data-id="element-4" />
      <MechanismSection data-id="element-5" />
      <DeliverablesSection data-id="element-6" />
      <AudienceSection data-id="element-7" />
      <HowItWorksSection data-id="element-8" />
      <ProofSection data-id="element-9" />
      <FAQSection data-id="element-10" />
      <OfferSection data-id="element-11" />
      <Footer data-id="element-12" />
    </div>;
}